// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1__e13cc5a357fe88b0d8a9","cls2":"CreateSocialItemModal-cls2___2529551468fba46180a CreateSocialItemModal-cls1__e13cc5a357fe88b0d8a9"};